import { StyleSheet, View } from 'react-native';
import { Divider } from '@ui-kitten/components';

import DateHelper from '../../../Helper/Date';
import routeList from '../../../Routes/list';
import { Listing, TableDetails } from '../../../RTK/api/reservations/types';
import themeStyle from '../../../Theme/styles';

import ItemContent from './ItemContent';

const SearchItem = ({
  item,
  onBook,
}: {
  item: Listing;
  onBook: (d: TableDetails) => void;
}) => {
  const { events, store, tables } = item;

  return (
    <View style={styles.wrapper}>
      {events.map((event, index) => {
        const { isLastStart, startFormatted, start } =
          DateHelper.getEventScheduleInfo(
            event.start_date,
            event.end_date,
            event.time_slots,
            event.available_days,
          );
        return (
          <ItemContent
            key={event.id}
            date={
              isLastStart
                ? startFormatted
                : DateHelper.formatDateWithText(
                    start,
                    event.end_date,
                    event.available_days,
                  )
            }
            image={event.image}
            isEvent={true}
            isLast={index === events.length - 1}
            link={`${routeList.RES_EVENT_DETAILS}?eventId=${event.id}&size=1`}
            location={event.location_address}
            name={event.name}
            storeName={store.name}
            time={DateHelper.formatTimeRangeArray(event.time_slots)}
          />
        );
      })}
      {events.length !== 0 && tables.length !== 0 && (
        <Divider style={themeStyle.divider} />
      )}
      {tables.map((table, index) => (
        <ItemContent
          key={table.id}
          description={table.item.description}
          image={table.item.image_url}
          isLast={index === tables.length - 1}
          location={store.location}
          name={`Book your table - ${table.name}`}
          storeName={store.name}
          onBook={() => onBook(table)}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    margin: -10, // to offset parent style
  },
  itemWrapper: {
    ...themeStyle.flex1,
    ...themeStyle.flexDirectionRowCenter,
    ...themeStyle.pageVerticalSpacing,
    ...themeStyle.pageHorizontalSpacing,
  },
  image: {
    ...themeStyle.spacingRight,
    width: 60,
    height: 60,
    borderRadius: 30,
  },
});

export default SearchItem;
